import { render } from "./BaseListField.vue?vue&type=template&id=87893024"
import script from "./BaseListField.vue?vue&type=script&lang=js"
export * from "./BaseListField.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__